/**
 * @desc 修改用户密码
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierAccountPasswordRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierAccount/update/password`, {
      method: "PUT",

      data: body,
      ...options,
    }),
  );
}
